import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { FaRegUser } from "react-icons/fa";
import fullScreen from "../../assets/icons/fullScreen.svg";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../Modal/ModalComponent";
import { Col, Dropdown, Row, Tooltip } from "antd";
import PrimaryButton from "../Buttons/PrimaryButton";
import { AppDispatch, RootState } from "../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import { getSponsorDetails } from "../../apis/actions/sponsor.actions";
import BasketComponent from "../basket/BasketComponent";
import { setEditMode } from "../../apis/slices/recipientSlice";
import { isRoleSponsor } from "../../domains/profile/sponsor/orphans/utils";
const ProfileIcons = () => {
  const dispatch = useDispatch<AppDispatch>();
  // State to manage submenu visibility
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [cookies, , removeCookie] = useCookies(["apiKey", "role"]);
  const OtpId =  useSelector(
    (state: RootState) => state?.recipient?.OtpId
  );
  useEffect(() => {
    dispatch(getSponsorDetails({ sponsor_id: OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );

  const role = cookies?.role;
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );
  const handleFullScreen = () => {
    const element = document.documentElement as any;
    const documentElement = document.documentElement as any;
    const isFullScreen = !!document.fullscreenElement;

    const action = isFullScreen
      ? document.exitFullscreen ||
        documentElement.mozCancelFullScreen ||
        documentElement.webkitExitFullscreen ||
        documentElement.msExitFullscreen
      : element.requestFullscreen ||
        element.mozRequestFullScreen ||
        element.webkitRequestFullscreen ||
        element.msRequestFullscreen;

    if (action) action.call(isFullScreen ? document : element);
    setIsFullscreen(!isFullScreen);
  };
  const handleLogout = () => {
    removeCookie("apiKey", { path: "/" });
    removeCookie("role", { path: "/" });
    navigate("/");
  };
  const confirmLogout = () => {
    handleLogout();
    setIsModalVisible(false);
  };

  const cancelLogout = () => {
    setIsModalVisible(false);
  };

  const items = [
    {
      key: "1",
      label: (
        <p
          className="takaful--item-dropdown"
          onClick={() =>
            navigate("/profile", {
              state: {
                selectedKey:
                  role !== "beneficiary"
                    ? "s4"
                    : (() => {
                        dispatch(setEditMode(true));
                        return "b1";
                      })(),
              },
            })
          }
        >
          تعديل الملف
        </p>
      ),
    },
    {
      key: "2",
      label: (
        <p
          className="takaful--item-dropdown"
          onClick={() => setIsModalVisible(true)}
        >
          تسجيل الخروج
        </p>
      ),
    },
  ];
  return (
    <div className="takaful--navbar-profile-icons">
      <Dropdown
        menu={{ items }}
        placement="bottom"
        overlayStyle={{ direction: "rtl", padding: "0 1rem 0 1rem" }}
      >
        <div className="takaful--navbar-profile-icon">
          <FaRegUser />
        </div>
      </Dropdown>
      <Tooltip
        overlayClassName="takaful--share-tooltip"
        placement="bottom"
        title={isFullscreen ? "تصغير الشاشة" : "تكبير الشاشة"}
      >
        <div
          className="takaful--navbar-profile-icon"
          onClick={handleFullScreen}
        >
          <img alt="" src={fullScreen} />
        </div>
      </Tooltip>

      {isRoleSponsor(role) && (
        <BasketComponent count={sponsor?.unpaid_booking_number} />
      )}
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={cancelLogout}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد تسجيل الخروج؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              title="لا"
              onClick={cancelLogout}
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmLogout}
            />
          </Col>
        </Row>
      </ModalComponent>
    </div>
  );
};

export default ProfileIcons;
